<template>
    <div class="plans">
        <BackgroundImage
            class="thin left"
            :data="heroData"
        />

        <PlansTiles :data="plansLocal.priceTiles" />

        <PlansTable :data="plansLocal.featuresTable" />

        <section
            class="faq-category-section"
            v-for="(item, index) in plansLocal.questions.items"
            v-bind:key="index"
        >
            <FaqCategory
                :item="item"
                :index="index"
            />
        </section>

        <RotatingWords
            id="get-the-app"
            :data="data?.rotatingWords"
        />
    </div>
</template>

<script>
import { apollo } from '@/mixins'
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getPlansContent } from '@/data/plans'

import BackgroundImage from '@/components/Images/BackgroundImageParallax.vue'
import PlansTiles from '@/components/Sections/PlansTiles.vue'
import PlansTable from '@/components/Sections/PlansTable.vue'
import FaqCategory from '@/components/Sections/FaqCategory.vue'
import RotatingWords from '@/components/Text/RotatingWords.vue'

export default {
    name: 'PlansView',
    mixins: [apollo],
    components: {
        BackgroundImage,
        PlansTiles,
        PlansTable,
        FaqCategory,
        RotatingWords
    },
    data() {
        return {
            // apollo mixin loads the page payload. We use it for the
            // RotatingWords outro AND for the hero background image
            // (the image asset still lives in Strapi; the local data
            // file just suppresses the text overlay).
            apolloId: 'plan'
        }
    },
    computed: {
        ...mapState(useStore, ['language']),
        plansLocal() {
            return getPlansContent(this.language)
        },
        /** Hero data: Strapi-fed image + locally suppressed text
         *  overlay (the title/description from plansLocal.hero are
         *  empty strings on purpose so Teaser inside
         *  BackgroundImageParallax renders nothing on top of the
         *  image). If Strapi has no image we fall back to whatever's
         *  in plansLocal.hero (null today). */
        heroData() {
            const localHero = this.plansLocal.hero
            const strapiImg = this.data?.fullWidthImage?.img
            return {
                title: localHero.title,
                description: localHero.description,
                img: strapiImg || localHero.img,
            }
        },
    },
}
</script>
